


















































import Vue from 'vue'
import store from '@/store'
import Product from '@/types/product'

export default Vue.extend({
  data() {
    return {
      product: {} as Product
    }
  },

  computed: {
    hasProduct(): boolean {
      return Object.keys(this.product).length > 0
    }
  },

  created() {
    (async () => {
      const categories = await this.fetchCateogries()
      const post = await this.fetchPost()
      // @ts-ignore
      this.product = this.format(post, categories)
    })()
  },

  mounted() {
    document.title = '制作事例'
  },

  watch: {
    'product.name'(value) {
      document.title = value
    }
  },

  methods: {
    async fetchPost(): Promise<Product> {
      const postId = this.$route.params.id
      console.log(postId)
      const query = new URLSearchParams({
        acf_format: 'standard',
        _embed: 'true'
      })
      const response = await fetch(`${process.env.VUE_APP_PRO_WP_SITE_URL}/wp-json/wp/v2/posts/${postId}?${query}`)
      return await response.json()
    },

    async fetchCateogries(): Promise<[]> {
      const response = await fetch(`${process.env.VUE_APP_PRO_WP_SITE_URL}/wp-json/wp/v2/categories?per_page=100`)
      return await response.json()
    },

    format(post, categories) {
      const data = {
        title: 'プロダクト名プロダクト名',
        description: 'プロダクトの説明プロダクトの説明プロダクトの説明プロダクトの説明プロダクトの説明プロダクトの説明プロダクトの説明プロダクトの説明プロダクトの説明プロダクトの説明プロダクトの説明',
        thumbnail: 'https://tokino.co.jp/wp-tokino/wp-content/uploads/2023/04/koujiya-1024x576.jpg',
        gallery: [
          {
            src: require('@/assets/image/client-work/one-umeboshi-each-day/1.webp'),
            caption: 'キャプションキャプションキャプション'
          }, {
            src: require('@/assets/image/client-work/one-umeboshi-each-day/2.webp'),
            caption: ''
          }, {
            src: require('@/assets/image/client-work/one-umeboshi-each-day/3.webp'),
            caption: 'キャプション'
          }, {
            src: require('@/assets/image/client-work/one-umeboshi-each-day/4.webp'),
            caption: ''
          }, {
            src: require('@/assets/image/client-work/one-umeboshi-each-day/5.webp'),
            caption: ''
          }, {
            src: require('@/assets/image/client-work/one-umeboshi-each-day/6.webp'),
            caption: ''
          },
        ],
        client: 40,
        categories:['カテゴリ1', 'カテゴリ2'],
        credits: [
          { kindof: 'クライアント', name: 'クレジット' },
          { kindof: 'エージェント', name: 'クレジット' },
          { kindof: '写真', name: 'クレジット' },
          { kindof: 'デザイン', name: 'クレジット' },
        ],
        updated: '2026.06'
      }      
      return data
    }
  }
})
